(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brands"]) return;
  try {
    
function initialiseBrandCarousel(container) {
  if (!window.jQuery || !window.jQuery.fn.owlCarousel) {
    return;
  }

  var $ = window.jQuery;

  $(container).find('.owl-brands').each(function() {
    var $carousel = $(this);

    if ($carousel.hasClass('owl-loaded')) {
      $carousel.trigger('destroy.owl.carousel');
    }

    if (!$carousel.children('.brand').length) {
      return;
    }

    $carousel.owlCarousel({
      loop: true,
      margin: 0,
      autoplay: false,
      dots: false,
      responsive: {
        0: {
          items: 1,
          nav: false,
          loop: true,
          autoplay: true,
          autoplayTimeout: 2000,
          autoplayHoverPause: true
        },
        768: {
          items: 3,
          nav: false,
          loop: true,
          autoplay: true,
          autoplayTimeout: 2000,
          autoplayHoverPause: true
        },
        1000: {
          items: 5,
          nav: false,
          loop: false,
          autoplay: false
        }
      }
    });
  });
}

if (window.jQuery) {
  window.jQuery(document).ready(function() {
    initialiseBrandCarousel(document);
  });
}

document.addEventListener('shopify:section:load', function(event) {
  initialiseBrandCarousel(event.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    

	$('.faq').click(function(){
    	$(this).children('.faq-answer').toggleClass('show');
		$(this).find('.faq-title-icon').toggleClass('flip');
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["members"]) return;
  try {
    

  $(document).ready(function(){
    $('.owl-members').owlCarousel({
        loop:true,
        margin:0,
        autoplay: false,
        dots: false,
        responsive:{
            0:{
                items:1,
                nav:false,
                loop:true,
                autoplay:true,
                autoplayTimeout:2000,
                autoplayHoverPause:true
            },
            768:{
                items:3,
                nav:false,
                loop:true,
                autoplay:true,
                autoplayTimeout:2000,
                autoplayHoverPause:true
            },
            1000:{
                items:5,
                nav:false,
                loop:false
            }
        }
    })
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"]) return;
  try {
    

  $(document).ready(function(){
    $('.owl-tabs').owlCarousel({
        loop:true,
        margin:0,
        autoplay: false,
        dots: false,
        responsive:{
            0:{
                items:1,
                nav:false,
                loop:true,
                autoplay:true,
                autoplayTimeout:2000,
                autoplayHoverPause:true
            },
            768:{
                items:1,
                nav:false,
                loop:true,
                autoplay:true,
                autoplayTimeout:2000,
                autoplayHoverPause:true
            },
            1000:{
                items:3,
                nav:false,
                loop:false
            }
        }
    })
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"]) return;
  try {
    

	$('.team-filter ul li').click(function(){

		$('.team-filter ul li').removeClass('active');
    	$(this).toggleClass('active');

		var filter = $(this).data("filter");

		$('.team-member').removeClass('active');
		$('.team-member.' + filter).addClass('active');

    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"]) return;
  try {
    

  $(document).ready(function(){
    $('.owl-testimonials').owlCarousel({
        items:1,
        nav:false,
        loop:true,
        margin:0,
        autoplay: false,
        dots: false,
        responsive:{
            0:{
                items:1,
                nav:false,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true
            },
            991:{
                items:1,
                nav:false,
                loop:true,
                autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true
            },
            1000:{
                items:1,
                nav:true,
                loop:true,
                autoplay:false
            }
        }
    })
  });


  } catch(e) { console.error(e); }
})();
})();
